<template>
  <div id="bg" class="bg">
    <div class="logoBox">会员注册</div>
    <div class="registerWrap">
      <div class="w1200">
        <div class="register clearfix" @keyup.13="doLogin">
          <div class="form-horizontal registerLeft fl">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px" class="demo-ruleForm" style="margin-top:40px;">
                <el-form-item label="用户名" prop="username">
                    <el-input v-model="ruleForm.username"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="mobile">
                    <el-input v-model="ruleForm.mobile"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="verificationCode" v-if="verificationCodeShow">
                    <el-input v-model="ruleForm.verificationCode"></el-input>
                    <img :src="img_src" class="verificationIMG" alt="点击刷新图片" @click="reflash"/>
                    <el-button type="primary" class="fr sendVerification" style="float:left;margin-top:10px;" @click="smsCodeSend" v-text="'发送验证码'"></el-button>
                </el-form-item>
                <el-form-item label="短信验证码" prop="smsCode" v-else>
                    <el-input v-model="ruleForm.smsCode"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input type="password" v-model="ruleForm.password" autocomplete="off" placeholder="输入6-20位字母、数字或符号"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="password_r">
                    <el-input type="password" v-model="ruleForm.password_r" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="邀请人手机号" prop="contacts_mobile">
                    <el-input v-model="ruleForm.contacts_mobile"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
                    <el-button @click="resetForm('ruleForm')">重置</el-button>
                    <router-link to="/login" style="margin-left:10px"><el-button>返回</el-button></router-link>
                </el-form-item>
                </el-form>
            </div>
            <div class="registerRight fr">
                <div class="rightFrom">
                    <div class="rightFromItem" style="margin-bottom: 15px;">已有帐号?</div>
                    <div class="rightFromItem" style="margin-bottom: 50px;">
                        <el-button @click="gotoLogin()">立即登录</el-button>
                    </div>
                    <div class="rightFromItem p">
                        <div class="title">注册用户的条件:</div>
                        <p>1. 必须是具有合法资格的药品生产企业或药品经 营企业，并且按照GSP的要求提供一切合法证照。</p>
                        <p>2. 凡不涉及药品采购的用户或供应商，亦将经过 必要的资格审核，准予申请专门的会员资格。</p>
                    </div>
                    <div class="rightFromItem p">
                        <div class="title">具体证件包括:</div>
                        <p>A、药品经营企业：提供《药品经营许可证》、《营业执照》、《药品经营质量管理规范》认证证书等复印件；</p>
                        <p>B、医疗单位：提供《医疗机构执业许可证》复印件；</p>
                        <p>C、药品生产企业：提供《药品生产许可证》《营业执照》、《药品生产质量管理规范》认证证书等复印件。</p>
                        <p>D、采购人员及提货人员的身份证复印件， 加盖购货单位法人代表印章或者签名的授权书， 授权书就当载明授权人（采购人员、提货人员）</p>
                    </div>
                    <div class="rightFromItem ps">注：以上资料均应加盖购货单位公章原印章</div>
                    
                </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { LoginService } from '../../service/login.service';
import Axios from 'axios'
export default {
    data() {
        var checkUsername = (rule,value,callback) => {
          if(!value) {
            return callback(new Error('用户名不能为空'))
          }else {
            var user = /^[A-Za-z]{1}[A-Za-z0-9]{5,15}$/
            if(user.test(value)) {
              callback()
            }else {
              return callback(new Error('6~18个字符，可使用字母、数字，需以字母开头'))
            }
          }
        }
        var checkPhone = (rule, value, callback) => {
          if (!value) {
              return callback(new Error('手机号不能为空'));
          } else {
              const reg = /^1[3456789]\d{9}$/
              if (reg.test(value)) {
                  callback();
              } else {
                  return callback(new Error('请输入正确的手机号'));
              }
          }
        };
        var checkinvitePhone = (rule, value, callback) => {
          const reg = /^1[3456789]\d{9}$/
          if (reg.test(value) || value === '') {
              callback();
          } else {
              return callback(new Error('请输入正确的手机号'));
          }
        }
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.ruleForm.password_r !== '') {
                this.$refs.ruleForm.validateField('password_r');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.ruleForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
      return {
        ruleForm: {
          username:'',
          mobile: '',
          password: '',
          password_r: '',
          verificationCode:'',
          smsCode:'',
          contacts_mobile: '',
        },
        rules: {
          mobile: [
            { required: true, message: '请输入手机号码', trigger: 'blur' },
            { validator: checkPhone, trigger: 'blur'},
            { min: 11, max: 11, message: '长度在 11 个字符', trigger: 'blur' }
          ],
          corporate_name: [
             { required: true, message: '请输入公司名称', trigger: 'blur' },
          ],
          username: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
            { validator: checkUsername, trigger: 'blur'}
          ],
          password: [
            { required: true,validator: validatePass, trigger: 'blur' }
          ],
          password_r: [
            { required: true,validator: validatePass2, trigger: 'blur' }
          ],
          verificationCode: [
            { required: true, message: '请输入验证码', trigger: 'blur' },
            { min: 5, max: 5, message: '长度在 5 个字符', trigger: 'blur' }
          ],
          smsCode: [
            { required: true, message: '请输入短信验证码', trigger: 'blur' },
            { min: 6, max: 6, message: '长度在 6 个字符', trigger: 'blur' }
          ],
          contacts_mobile:[
            { validator: checkinvitePhone, trigger: 'blur'},
          ]
        },
        img_src: '',
        verificationCodeShow: true,
        timerData: 60
      };
    },
    methods: {
       submitForm(formName) {
        this.$refs[formName].validate(async(valid) => {
          if (valid) {
            delete this.ruleForm.verificationCode
            LoginService.register(this.ruleForm).then(()=>{
              this.$message.success("注册成功")
              setTimeout(()=>{
                this.$router.push('/login')
              }, 2000)
            })
          } else {
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.verificationCodeShow = true
      },
      gotoLogin() {
          this.$router.push('/login')
      },
      reflash() {
        var url = 'https://api.goodyiyao.cn/web/other/digitalVerificationCode?model=userRegister'
        let that = this
        Axios.get(url,{ responseType: 'arraybuffer',withCredentials: true}).then(function(res){
          let codeImg =  'data:image/png;base64,' + btoa(
          new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ''))
          that.img_src = codeImg
        })
      },
      smsCodeSend() {
        
        this.$refs.ruleForm.validateField('mobile',async (errMsg) => {
          if(errMsg) {
            console.log(errMsg)
          }else{
            await LoginService.setCheckNumber({
              type:'mobile',
              account:this.ruleForm.mobile,
              model:'userRegister',
              code_num:this.ruleForm.verificationCode
            }).then(()=>{
              this.$message.success('短信已发送')
              this.verificationCodeShow = false
            })
          }
        })
      }
      // async getRegionLeave(level,parent_id) {
      //   const data = await LoginService.getArea(level,parent_id)
      //   this.regionLeave[level-1].data = data

      //   if(level === 2) {
      //     this.ruleForm.region.city = ''
      //     this.ruleForm.region.district = ''
      //     this.ruleForm.region.twon = ''
      //   }
      //   if(level === 3) {
      //     this.ruleForm.region.district = ''
      //     this.ruleForm.region.twon = ''
      //   }
      // }
    },
    created() {
      this.reflash()
      //this.getRegionLeave('1','0')
    }
  }
</script>

<style scoped>
  .logoBox{
    width: 1200px;
    height: 164px;
    line-height: 164px;
    font-size: 38px;
    text-indent: 285px;
    text-align: left;
    color: #727272;
    background: url('../../assets/images/views/logo.png') left center no-repeat;
    margin: 0 auto;
  } 
  .registerWrap {
    background: url('https://api.goodyiyao.cn/static/upload/other/register.jpg') center center no-repeat;
    background-size: 100%;
  }
  .w1200{
    margin: 0 auto;
    position: relative;
    height: 100%;
    padding: 95px 0 110px;
  }
  .register{
    width: 1198px;
    right: 0;
    background: #fff;
    border: 1px solid #c3bfc1;
  }
  .registerLeft{
      width: 680px;
      height: 100%;
  }
  .registerRight{
      width: 502px;
      border-left:  1px solid #d9d9d9;
      padding-bottom: 15px;
      padding-right: 15px;
  }
  .rightFrom{
      margin-top: 40px;
      margin-left: 20px;
      text-align: left;
  }
  .rightFromItem.p{
      margin-bottom: 25px;
  }
  .rightFromItem.p .title{
      margin-bottom: 25px;
      font-weight: bold;
  }
  .rightFromItem.p p{
      font-size: 14px;
  }
  .rightFromItem.ps{
      color: #e20c0c;
      text-align: center;
      font-size: 14px;
  }
  .login-btn {
    background-color: whitesmoke;
  }
  .logo {
    font-family: "DejaVu Sans Mono";
    color: lightblue;
    font-size: 50px;
  }
  .form-horizontal input{
    width: 100%;
    height: 48px;
    line-height: 48px;
    border: 1px solid #dbdee0;
    border-radius: 3px;
    text-indent: 3.5em;
  }
  .userform{
    background: url('../../assets/images/icon/personIcon.png') 12px center no-repeat;
  }
  .passwordform{
    background: url('../../assets/images/icon/lockIcon.png') 12px center no-repeat;
  }
  .loginIn{
    width: 80%;
    height: 51px;
  }
  .messageLogin .passwordform{
    width: 225px;
  }
  .verificationIMG{
    width: 145px;
    float: left;
    margin-right: 3px;
    margin-top: 10px;
  }
</style>

<style>
    .register .el-form-item__label{
        padding: 0 20px 0 0;
        line-height: 35px;
    }
    .register .el-input__inner{
        width: 290px;
        float: left;
    }
    .register .el-form-item__content{
        line-height: inherit;
    }
    .register .el-input.el-input--suffix{
        height: 40px;
    }
    .shotForm{
      text-align: left;
    }
    .shotForm .el-form-item__content{
        width: 290px;
    }
    .shotForm .el-input,.shotForm .el-input__inner{
        width: 145px;
    }
</style>